import { render, staticRenderFns } from "./LapMediciList.vue?vue&type=template&id=6ab3e129"
import script from "./LapMediciList.vue?vue&type=script&lang=js"
export * from "./LapMediciList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports